import { useCallback, useState } from "react";
import useIsMounted from "./useIsMounted";
import { CustomDrawerProps } from "components/custom-drawer/CustomDrawer";

const useCustomDrawer = () => {
  const [drawerProps, setDrawerProps] = useState<CustomDrawerProps>({
    open: false,
    onClose: () => {},
    heading: "",
    headingComponent: <></>,
    children: <></>,
    width: undefined,
  });

  const isMounted = useIsMounted();

  const showDrawer = useCallback(
    ({
      onClose = () => {},
      heading = "",
      headingComponent = <></>,
      children = <></>,
      width = undefined,
    }: Omit<CustomDrawerProps, "open">) => {
      if (isMounted()) {
        setDrawerProps({
          open: true,
          onClose,
          heading,
          headingComponent,
          children,
          width,
        });
      }
    },
    [isMounted]
  );

  const hideDrawer = () => {
    if (isMounted()) {
      setDrawerProps((state) => ({
        ...state,
        open: false,
      }));
    }
  };

  return {
    showDrawer,
    hideDrawer,
    drawerProps,
  };
};

export default useCustomDrawer;
